// Generic Validation Function
export const validateField = (name, value) => {
  if (!value.trim()) {
    return `${name.replace(/([A-Z])/g, " $1")} is required!`;
  }
  return "";
};
